/**
 * This module contains the UI
 * to build the trigger instruction category
 */

// TODO:
// - reduce unneeded notifications
// - unbind events of removed UI elements
// - unify styles

(function() {
  const $ = require('jQuery');
  const instruction_widgets = require('../instruction_widgets');
  const icons = require('../../icons');
  const widgets = require('../widgets');
  const helpers = require('../../helpers');
  const utils = require('./utils');

  const { autocompleteComponent } = require('../vse_ui/vse_components/base_components');

  function create(pParameters) {
    const lLibrary = pParameters.library;
    const lApp = pParameters.application;
    const lSequence = pParameters.sequence;
    let lInstructionListener = {};
    const lInstruction = pParameters.instruction;
    const _lDiv = $('<div class="ml_instruction h_layout"/>');
    const _lCard = widgets.card(icons[lInstruction.getCategory()], function () {
      lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
    }).attr('id', widgets.idGenerator.nextInstructionId());
    const _lParameterMap = {};
    let _lFilteredActionsSet;
    // Note (alevy): this function does not return a widget
    // it adds widgets to _lCard
    const _parameterWidget = function (pParameterInfo, pParameter) {
      let _lWidget;

      switch (pParameterInfo.format) {
        // Note(alevy): This is to build
        // the generate event instruction
        case 'string':
          if (pParameter == 'packMessage' ) {
            _lWidget = autocompleteComponent(
              helpers.transformToTitleCase(pParameterInfo.name),
              pParameterInfo.description,
              lInstruction.getParameter(pParameter),
              lApp.listAllApplicationParameterNames(),
              (pValue) => { lInstruction.setParameter(pParameter, pValue); },
              [helpers.getExpressionValidationFunction(lApp.getParametersObject())],
            ).widget;
          }  else if (pParameter == 'variableOutputName' ) {
            // Check if this variable already exists
            let variableObject = lApp.getParameterObjectByName(lInstruction.getParameter(pParameter));

            // If the variable does not exist, create a new Application Parameter 'unpackConst'
            if  (!variableObject) {
              variableObject = lApp.addApplicationParameter('unpackConst');
              lInstruction.setParameter(pParameter, variableObject.name);
            }

            _lWidget = widgets.applicationPackParameterWidget(lApp, variableObject, lSequence, lInstruction, pParameter);
            lInstructionListener = {
              /**  Listens to when a communication instruction parameter is changed (unpack or sendPack)
                *   When that occurs, delete the application parameter (unpack variable)
                */
              onCommunicationMethodChange: function(removeInstructionIndex) {
                if (removeInstructionIndex == lSequence.getInstructionIndex(lInstruction)) {
                  lApp.removeApplicationParameter(variableObject.id);
                  lInstruction.removeListener(lInstructionListener);
                }
              }
            };
            lInstruction.addListener(lInstructionListener);
          } else if(pParameter == 'message' ) {
            _lWidget = instruction_widgets.logMessageWidget(pParameterInfo.name, lApp, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            });
          } else {
            _lWidget = widgets.stringWidget(pParameterInfo.name, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            }, [helpers.validateURL], { allowEmpty: true });
            _lWidget.css('grid-column', '1 / -1');
          }
          break;

        case 'oneOf':
          _lWidget = widgets.listWidget(pParameterInfo.name, pParameterInfo.values, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
            lInstruction.setParameter(pParameter, pValue);
          });
          break;

        default:
          _lWidget = widgets.baseWidget(pParameterInfo.name).append($('<div>' + pParameterInfo.format + ' not supported</div>'));
          break;
      }

      if (_lWidget) {
        _lWidget.addClass('v_layout spaced');
        _lParameterMap[pParameter] = _lWidget;
        _lCard.parameters.append(_lWidget);
      }
    };
    const _lActionSet = lLibrary.getInstructionSet()[lInstruction.getCategory()];
    let _lActions;
    const _onAction = function (pAction) {
      lInstruction.setName(pAction);
    };
    const buildInstruction = utils.buildInstruction(_parameterWidget);

    _lCard.icon.find('h5').addClass('ml_number');
    _lCard.icon.removeClass('ml_icon').addClass('ml_icon_instruction_widget');

    if (_lActionSet) {
      // Please see VentionCo/mm-vention-control#569
      const lReplaceCategory = utils.replaceCategory(lInstruction.getCategory());
      _lFilteredActionsSet = utils.getActions(lLibrary, lInstruction);
      _lActions = widgets.listWidget(lReplaceCategory, utils.getActionList(_lFilteredActionsSet), 'Action to be performed', lInstruction.getName(), _onAction);
      buildInstruction(_lCard, lInstruction, _lActions, _lFilteredActionsSet);
      _lCard.append($('<div class="ml_animated_background"/>'));
      _lDiv.append(_lCard);

      _lActions.find('h5').text('Send message to');

      // Instruction and Application listeners
      lInstruction.addListener(utils.getInstructionListener({
        actions: _lActions,
        buildInstruction: buildInstruction,
        card: _lCard,
        filteredActionsSet: _lFilteredActionsSet,
        instruction: lInstruction,
        library: lLibrary,
        parameterMap: _lParameterMap,
      })
      );
    }

    return _lDiv;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    create: create,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
})();
